import React from 'react';
import PropTypes from "prop-types";
/**
 * Resize handler component we are using the start the drag action.
 * This is currently a simple dumb icon that requires external support for handling placement.
 */

var ResizeHandle = function ResizeHandle(_ref) {
  var onMouseDown = _ref.onMouseDown;
  return /*#__PURE__*/React.createElement("div", {
    className: "resize-textarea__wrapper__drag-handle",
    onMouseDown: onMouseDown
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.354 9.354l-.707-.707-13 13 .707.707zm0 7l-.707-.707-6 6 .707.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};

ResizeHandle.propTypes = {
  onMouseDown: PropTypes.func.isRequired
};
export default ResizeHandle;
//# sourceMappingURL=ResizeHandle.js.map